import styled from 'styled-components';

export const VideoContainer = styled.div`
  border: 1px solid var(--green-lightest);
  left: 0; width: 100%; 
  height: 0; 
  position: relative; 
  padding-bottom: 56.1972%;
  margin-bottom: 5rem;

`;
